import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../styles/menu.scss";
import { FaRegEdit } from "react-icons/fa";
import { toast } from "react-toastify";


const Cliente = () => {
    const [clientes, setClientes] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(""); // "edit" ou "add"
    const [currentCliente, setCurrentCliente] = useState(null);
    const [newCliente, setNewCliente] = useState({ NOME_CLIENTE: "", FL_ATIVO: true });

    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL; 
        const fetchClientes = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    throw new Error("Usuário não autenticado.");
                }

                const response = await axios.get(`${API_URL}/api/menu/clientes`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                setClientes(response.data);
            } catch (error) {
                console.error("Erro ao buscar clientes:", error.response?.data || error.message);
                if (error.response?.status === 401) {
                    navigate("/login");
                }
            }
        };

        fetchClientes();
    }, [navigate]);

    const handleEdit = (cliente) => {
        setCurrentCliente(cliente);
        setModalType("edit");
        setModalOpen(true);
    };

    const handleAdd = () => {
        setNewCliente({ NOME_CLIENTE: "", FL_ATIVO: true });
        setModalType("add");
        setModalOpen(true);
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem("authToken");

            if (modalType === "edit") {
                const payload = {
                    NOME_CLIENTE: currentCliente.NOME_CLIENTE,
                    FL_ATIVO: currentCliente.FL_ATIVO ? 1 : 0, // Convertendo checkbox para número
                };

                await axios.put(
                    `${API_URL}/api/menu/clientes/${currentCliente.ID_CLIENTE}`,
                    payload,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                toast.success("Cliente editado com sucesso!")
            } else if (modalType === "add") {
                const payload = {
                    NOME_CLIENTE: newCliente.NOME_CLIENTE,
                    FL_ATIVO: newCliente.FL_ATIVO ? 1 : 0,
                };

                await axios.post(`${API_URL}/api/menu/clientes`, payload, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                toast.success("Cliente Criado com sucesso!")
            }

            setModalOpen(false);

            // Recarregar clientes
            const response = await axios.get(`${API_URL}/api/menu/clientes`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setClientes(response.data);
        } catch (error) {
            console.error("Erro ao salvar cliente:", error.response?.data || error.message);
        }
    };


    const handleCancel = () => {
        setModalOpen(false);
        setCurrentCliente(null);
    };

    return (
        <div className="page-container">
            <h1>Clientes</h1>
            <div className="container-login100-form-btn">
                <button className="login100-form-btn_cad" onClick={handleAdd}>
                    Cadastrar Novo Cliente
                </button>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Ativo</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {clientes.map((cliente) => (
                        <tr key={cliente.ID_CLIENTE}>
                            <td>{cliente.NOME_CLIENTE}</td>
                            <td>{cliente.FL_ATIVO ? "Sim" : "Não"}</td>
                            <td>
                                <button onClick={() => handleEdit(cliente)}>{<FaRegEdit />}</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Modal */}
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        {modalType === "edit" && <h2>Editar Cliente</h2>}
                        {modalType === "add" && <h2>Cadastrar Cliente</h2>}
                        <label>
                            Nome:
                            <input
                                type="text"
                                value={
                                    modalType === "edit"
                                        ? currentCliente?.NOME_CLIENTE
                                        : newCliente.NOME_CLIENTE
                                }
                                onChange={(e) => {
                                    if (modalType === "edit") {
                                        setCurrentCliente({
                                            ...currentCliente,
                                            NOME_CLIENTE: e.target.value,
                                        });
                                    } else {
                                        setNewCliente({
                                            ...newCliente,
                                            NOME_CLIENTE: e.target.value,
                                        });
                                    }
                                }}
                            />
                        </label>
                        {modalType === "edit" && (
                            <label>
                                Ativo:
                                <input
                                    type="checkbox"
                                    checked={currentCliente?.FL_ATIVO}
                                    onChange={(e) =>
                                        setCurrentCliente({
                                            ...currentCliente,
                                            FL_ATIVO: e.target.checked,
                                        })
                                    }
                                />
                            </label>
                        )}
                        <div className="modal-actions">
                            <button onClick={handleSave}>Salvar</button>
                            <button onClick={handleCancel}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Cliente;
